// /admin/reconciliation resolves by audience (Neel feedback #7):
//   - operators get the bank-connect onboarding flow (OperatorReconciliation);
//   - CoLiviq staff get the finAPI reconciliation review page.
// This replaces the OperatorRouteGate that used to bounce operators away —
// they now have a real reconciliation surface.
import { useAuth } from "@/contexts/AuthContext";
import { OperatorReconciliation } from "@/components/admin/OperatorReconciliation";
import V2ReconciliationReviewPage from "@/pages/admin/v2/ReconciliationReviewPage";

export default function ReconciliationRouter() {
  const { isOperatorPortal } = useAuth();
  return isOperatorPortal ? (
    <OperatorReconciliation />
  ) : (
    <V2ReconciliationReviewPage />
  );
}
